export default "/static/f8a6fc052cf399aa.png"